module.exports = __webpack_public_path__ + "static/media/BCI_DEF.759068a6.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle21/BCI_DEF.mp4
 ** module id = 382
 ** module chunks = 0
 **/